import { styled } from '@mui/material';
import { getCssPx } from 'components/ui/utilities/zoom';
import { getLegacyShellZoomCompensation } from 'context/ZoomContext';

interface WorkspaceSurfaceStyleProps {
  shouldConstrainHeight?: boolean;
  shouldCompensateZoom?: boolean;
}

const shouldForwardWorkspaceSurfaceProp = (prop: PropertyKey) => ![
  'shouldConstrainHeight',
  'shouldCompensateZoom',
].includes(String(prop));

export const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const ShellChrome = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  minWidth: 0,
  transformOrigin: 'top left',
  width: '100%',
  zoom: getLegacyShellZoomCompensation(),
});

export const ContentArea = styled('main')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
}));

export const PageContent = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxSizing: 'border-box',
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  padding: `0 ${getCssPx(16)}`,
}));

export const WorkspaceSurface = styled('div', {
  shouldForwardProp: shouldForwardWorkspaceSurfaceProp,
})<WorkspaceSurfaceStyleProps>(({ shouldConstrainHeight = false, shouldCompensateZoom = false }) => {
  const workspaceZoomCompensation = shouldCompensateZoom ? getLegacyShellZoomCompensation() : 1;

  return {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    ...(shouldConstrainHeight ? {
      height: '100%',
      maxHeight: '100%',
      overflow: 'hidden',
    } : {}),
    minHeight: 0,
    minWidth: 0,
    transformOrigin: 'top left',
    width: '100%',
    zoom: workspaceZoomCompensation,
  };
});

export const NavigationTourTarget = styled('div')({
  width: '100%',
});
